import { render } from "./ImportPurchasesReturn.vue?vue&type=template&id=1c09d2dc"
import script from "./ImportPurchasesReturn.vue?vue&type=script&lang=js"
export * from "./ImportPurchasesReturn.vue?vue&type=script&lang=js"

import "./ImportPurchasesReturn.vue?vue&type=style&index=0&id=1c09d2dc&lang=css"
script.render = render

export default script